import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import QuickSearch from '../QuickSearch/QuickSearch';
import { filterInstitution } from './util';
import styles from './style.css';

export const Institutions = ({ institutions }) => {
  const { next } = useContext(FlowContext);
  const filteredInstitutions = filterInstitution(institutions);
  const topInstitutions = filteredInstitutions.slice(0, 12);

  return topInstitutions.map(institution => {
    const { csdId: custodianID, custodianName } = institution;

    return (
      <div
        tabIndex={0}
        role="button"
        className="tile"
        key={institution.toString()}
        id={institution.custodianName}
        onKeyPress={event => {
          if (event.charCode === 13) {
            next({
              custodianID,
              custodianName
            })();
          }
        }}
        onClick={next({
          custodianID,
          custodianName
        })}>
        {institution.custodianName}
        <style jsx>{styles}</style>
      </div>
    );
  });
};

export const InstitutionQuickSearch = ({
  institutions,
  setManualProviderName
}) => {
  return (
    <QuickSearch
      institutions={institutions}
      setManualProviderName={setManualProviderName}
      mode="NASU"
    />
  );
};

const InstitutionSelection = ({ institutions, setManualProviderName }) => {
  return (
    <div className="institutions">
      <div className="quick-search">
        <InstitutionQuickSearch
          institutions={institutions}
          setManualProviderName={setManualProviderName}
        />
      </div>
      <div className="institution-grid">
        <Institutions institutions={institutions} />
      </div>

      <style jsx>{styles}</style>
    </div>
  );
};

export default InstitutionSelection;
